import { AbstractIconComponent } from './abstract.icon'
import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'icon-tow-location-pin',
  templateUrl: './tow-location-pin.icon.html',
  styleUrls: ['tow-location-pin.icon.scss'],
  imports: [CommonModule],
})
export class TowLocationPinIconComponent extends AbstractIconComponent {
  @Input() isSelected = true
  @Input() small = false
}
